import { HTMLAttributes, forwardRef } from 'react';

import {
  Avatar as MuiAvatar,
  Theme,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

import { IdentityRefFragment } from '@spotify/confidence-graphql';

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    small: {
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
    medium: {
      width: theme.spacing(5),
      height: theme.spacing(5),
    },
    large: {
      width: theme.spacing(6),
      height: theme.spacing(6),
    },
  });

export interface AvatarProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'classes'>,
    WithStyles<typeof styles> {
  identity: IdentityRefFragment | null;
  size?: 'small' | 'medium' | 'large';
}

const Avatar = forwardRef<HTMLDivElement, AvatarProps>((props, ref) => {
  const { className, classes, identity, size = 'medium', ...rest } = props;

  return (
    <MuiAvatar
      ref={ref}
      src={identity?.pictureUri ?? ''}
      alt={identity?.displayName ?? identity?.name ?? ''}
      className={classNames(classes.root, classes[size], className)}
      {...rest}
    />
  );
});

Avatar.displayName = 'ActivityFeedItem.Avatar';

export default withStyles(styles)(Avatar);
